<template>
  <div v-if="currentUser !== null" class="jd-list-wrapper">
    <div v-if="loading || isSubmitting || isLoading" class="loader-container">
      <Loader />
    </div>
    <div class="d-flex flex-column h-100" v-else>
      <div class="jd-header-fixed d-flex align-items-center justify-content-end">
        <button 
          type="button" 
          class="close" 
          @click="$emit('closeModal')" 
          aria-label="Close"
          style="font-size: 28px; font-weight: 300; opacity: 0.5;"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      
      <section class="catg-area ptop-5" ref="jdListContainer">
      <div class="container" style="max-width: 95%;">
        
        <!-- SECTION 1: Scouted Jobs -->
        <div class="mb-4">
          <h5 class="font-weight-bold mb-3">登録者がスカウト希望した求人</h5>
          <div
            v-if="scoutedItems && scoutedItems.length > 0"
            class="scouted-jd-list"
          >
            <JDListItem
              v-for="jd in scoutedItems"
              :key="jd._id"
              :jd="jd"
              :isSubmitting="isSubmitting"
              :profile="applicantProfile"
              :isSelected="applicantJD && applicantJD._id === jd._id"
              @open-info="openJdInfo"
              @toggle-select="(jd) => toggleJDMatch(jd, applicantJD && applicantJD._id === jd._id)"
              class="mb-2"
            />
          </div>
          <div v-else>
            <p>スカウト希望した求人はありません。</p>
          </div>
        </div>

        <!-- SECTION 2: Selected Job -->
        <div class="mb-4">
          <h5 class="font-weight-bold mb-3">選択中の求人</h5>
          <div v-if="applicantJD">
            <JDListItem
              :jd="applicantJD"
              :isSubmitting="isSubmitting"
              :profile="applicantProfile"
              :isSelected="true"
              @open-info="openJdInfo"
              @toggle-select="(jd) => toggleJDMatch(jd, true)"
            />
          </div>
          <div v-else>
            <p>選択中の求人はありません。</p>
          </div>
        </div>

        <!-- SECTION 3: All Jobs / Search -->
        <div class="mb-4">
          <div class="d-flex align-items-center mb-3">
             <h5 class="font-weight-bold me-4 mb-0">すべての求人</h5>
             <div class="toggle-container d-flex align-items-center" style="background: transparent; height: auto; width: auto;">
              <label class="mb-0 me-2 font-weight-bold" style="color: #000; font-size: 16px;">AIによるマッチ求人のみ表示</label>
              <toggle-button
                v-model="userBasedMatching"
                :sync="true"
                @change="handleToggle"
                :width="60"
                :height="26"
              />
            </div>
          </div>

          <div class="d-flex align-items-center mb-3">
            <div class="custom-control custom-radio me-4">
              <input type="radio" id="andSearch" name="searchType" class="custom-control-input" value="all" v-model="currentSearchType">
              <label class="custom-control-label" for="andSearch">AND検索（すべての単語を含む）</label>
            </div>
            <div class="custom-control custom-radio">
              <input type="radio" id="orSearch" name="searchType" class="custom-control-input" value="any" v-model="currentSearchType">
              <label class="custom-control-label" for="orSearch">OR検索（いずれかの単語を含む）</label>
            </div>
          </div>

          <!-- Search Input -->
          <div class="d-flex align-items-center mb-3">
            <label class="me-3 mb-0 font-weight-bold" style="min-width: 140px;">キーワード絞り込み</label>
            <div class="search-input-wrapper flex-grow-1 me-3">
              <input
                type="text"
                v-model="currentSearchQuery"
                placeholder="複数キーワードの検索はスペース区切り"
                class="form-control"
                @keyup.enter="handleSearch"
                style="height: 38px;"
                :disabled="userBasedMatching"
              />
            </div>
            <button
              type="button"
              class="btn btn-info text-white font-weight-bold search-btn-custom"
              @click="handleSearch"
              :disabled="userBasedMatching"
            >
              検索
            </button>
          </div>

          <!-- Job List -->
          <div class="results-section" style="position: relative; min-height: 200px;">
            <div v-if="shouldShowJobList">
               <JDRow
                v-for="jd in displayedItems"
                :jd="jd"
                :key="jd._id"
                :isSubmitting="isSubmitting"
                @openJdInfo="openJdInfo"
                @matchJd="toggleJDMatch"
                :profile="applicantProfile"
                :radioName="'jd_select'"
              />
               <div class="pagination-area mt-3" v-if="totalPages > 1">
                <GlobalPaginate
                  :total-page="totalPages"
                  :callback="handlePageChange"
                  :currentPage="currentPage"
                />
              </div>
            </div>
          </div>
        </div>

      </div>
      </section>
    </div>
  </div>
</template>

<script>
import ApiService from '@/service/apiService';
import GlobalPaginate from '@/components/utils/GlobalPaginate.vue';
import Loader from '../../../../utils/Loader.vue';
import Api from '@/config/api';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import moment from 'moment';
import JDRow from './JDRow.vue';
import JDListItem from './JDListItem.vue';

export default {
  name: 'JDList',
  components: { JDRow, JDListItem, GlobalPaginate, Loader },
  props: ['applicantId', 'isLoading'],
  data() {
    return {
      clientPage: 1,
      loading: false,
      isSubmitting: false,
      pageSize: 100,
    };
  },
  methods: {
    ...mapMutations({
      setProfileView: 'setProfileView',
      setPreservedState: 'profileJd/setPreservedState',
      setUserBasedMatching: 'setUserBasedMatching',
      setServerPage: 'profileJd/setServerPage',
      setServerTotalPages: 'profileJd/setServerTotalPages',
      setServerJds: 'profileJd/setServerJds',
      setRecommendedJds: 'profileJd/setRecommendedJds',
      setFilteredJds: 'profileJd/setFilteredJds',
      setServerSearchConditions: 'profileJd/setServerSearchConditions',
    }),
    ...mapActions({
      toggleJobseekerSelection: 'toggleJobseekerSelection',
    }),
    async handlePageChange(page) {
      if (this.userBasedMatching) {
        this.clientPage = page;
      } else {
        await this.loadServerJDs(this.buildParams(page));
      }
      this.scrollToTop();
    },
    async handleToggle({ value }) {
      this.setUserBasedMatching(value);
      if (value && this.filteredJDs.length === 0) {
        await this.loadRecommendedJDs();
      } else if (!value && this.serverJDs.length === 0) {
        await this.loadServerJDs(this.buildParams(1));
      }
    },
    handleSearch() {
      this.loadServerJDs(this.buildParams(1));
    },

    async loadRecommendedJDs() {
      this.loading = true;
      try {
        const response = await ApiService.get(
          Api.endpoints.USER_BASED_MATCHING(this.applicantId, { isNewPanel: true})
        );
        const recommendedData = response.data.data;

        if (!recommendedData || recommendedData.length === 0) {
          this.setUserBasedMatching(false);
          await this.loadServerJDs(this.buildParams(1));
          return;
        }
        this.setRecommendedJds(recommendedData);

        let filteredJDs = [...this.recommendedJDs].filter((jd) =>
          this.applicantJD ? jd._id !== this.applicantJD._id : true
        );
        this.setFilteredJds(filteredJDs);
      } catch (error) {
        console.error('Error loading recommended JDs:', error);
        this.setUserBasedMatching(false);

        await this.loadServerJDs(this.buildParams(1));
      } finally {
        this.loading = false;
      }
    },

    async loadServerJDs(params = {}) {
      this.loading = true;
      try {
        const response = await ApiService.get(
          Api.endpoints.ALL_JDS,
          {},
          params
        );

        const { jDs, totalPages } = response.data.data;
        this.setServerJds(jDs);
        this.setServerTotalPages(totalPages);
        this.setServerPage(params.page);
      } finally {
        this.loading = false;
      }
    },

    async toggleJDMatch(jd, unselect) {
      this.isSubmitting = true;
      try {
        const data = {
          jobseekerId: this.applicantId,
        };
        data.timestamp = moment().format('YYYY-MM-DD HH:mm');

        await this.toggleJobseekerSelection({
          jd,
          unselect,
          id: this.applicantId,
          data,
        });
        if (this.userBasedMatching) {
          if (unselect) {
            let jds = [...this.filteredJDs];
            jds.push(jd);
            this.setFilteredJds(jds);
          } else {
            let jds = [...this.recommendedJDs];
            const filteredJds = jds.filter((jD) => jD._id !== jd._id);
            this.setFilteredJds(filteredJds);
          }
          this.clientPage = 1;
        } else if (this.serverJDs.length > 0) {
          this.loadServerJDs(this.buildParams(1));
        }
        this.isSubmitting = false;
      } catch (err) {
        console.log(err);
        this.isSubmitting = false;
        this.parseErrorResponse(err.response);
      }
    },
    buildParams(page = 1) {
      const params = { page };

      if (this.applicantId) {
        params.jobseekerId = this.applicantId;
      }

      const { jdSearch, searchType } = this.serverSearchConditions;

      if (jdSearch && jdSearch.trim()) {
        if (searchType === 'all') {
          params.jdSearchAnd = jdSearch;
        } else {
          params.jdSearchOr = jdSearch;
        }
      }

      if (this.applicantJD && this.applicantJD._id) {
        params.excludeJD = this.applicantJD._id;
      }

      return params;
    },

    openJdInfo(jd) {
      const scrollPosition = this.$refs.jdListContainer.scrollTop || 0;
      this.setProfileView({
        view: 'jdInfo',
        individualJD: jd,
        applicantJD: this.applicantJD,
        userBasedMatching: this.userBasedMatching,
      });
      this.setPreservedState({
        scrollPosition,
      });
    },
    scrollToTop() {
      this.$nextTick(() => {
        const modalBody = document.querySelector('.modal-body');
        const tableHeader =
          modalBody && modalBody.querySelector('.catg-area thead');

        if (tableHeader) {
          tableHeader.scrollIntoView({
            behavior: 'auto',
            block: 'start',
          });
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      getUserBasedMatching: 'getUserBasedMatching',
      profileView: 'getProfileView',
      serverPage: 'profileJd/getServerPage',
      serverTotalPages: 'profileJd/getServerTotalPages',
    }),
    ...mapState({
      applicantJD: ({ applicant }) => applicant.applicantJD,
      applicantProfile: ({ applicant }) => applicant.profile,
      preservedState: ({ profileJd }) => profileJd.preservedState,
      serverJDs: ({ profileJd }) => profileJd.serverJDs,
      recommendedJDs: ({ profileJd }) => profileJd.recommendedJDs,
      filteredJDs: ({ profileJd }) => profileJd.filteredJDs,
      serverSearchConditions: ({ profileJd }) =>
        profileJd.serverSearchConditions,
    }),

    currentSearchQuery: {
      get() {
        return this.serverSearchConditions.jdSearch;
      },
      set(value) {
        this.setServerSearchConditions({
          ...this.serverSearchConditions,
          jdSearch: value,
        });
      },
    },

    currentSearchType: {
      get() {
        return this.serverSearchConditions.searchType;
      },
      set(value) {
        this.setServerSearchConditions({
          ...this.serverSearchConditions,
          searchType: value,
        });
      },
    },

    userBasedMatching: {
      get() {
        return this.getUserBasedMatching;
      },
      set(value) {
        this.setUserBasedMatching(value);
      },
    },
    currentPage() {
      return this.userBasedMatching ? this.clientPage : this.serverPage;
    },
    totalPages() {
      if (this.userBasedMatching) {
        return Math.ceil(this.filteredJDs.length / this.pageSize);
      }
      return this.serverTotalPages;
    },

    displayedItems() {
      if (this.userBasedMatching) {
        const start = (this.clientPage - 1) * this.pageSize;
        const end = start + this.pageSize;
        return this.filteredJDs.slice(start, end);
      }
      return this.serverJDs;
    },
    scoutedItems() {
      // Get the scouted jobs from applicant profile
      const scoutedJobs = this.applicantProfile && this.applicantProfile.scouted_jobs
        ? this.applicantProfile.scouted_jobs
        : [];

      // Transform to match the expected structure
      const transformedJobs = scoutedJobs.map(scoutedJob => ({
        _id: scoutedJob.jobDetails._id,
        job_title: scoutedJob.jobDetails.job_title,
        company: scoutedJob.jobDetails.company,
        location: scoutedJob.jobDetails.location || '',
        qualification: scoutedJob.jobDetails.job_description || '',
        job_description: scoutedJob.jobDetails.job_description,
        jd_url: scoutedJob.jobDetails.jd_url,
        highlights: scoutedJob.jobDetails.highlights || [],
        // Add any other properties that JDRow expects
        isScouted: true, // Flag to identify this as a scouted JD
        scoutedJobId: scoutedJob._id, // Keep reference to original scouted job
        scoutedStatus: scoutedJob.status // Keep status for sorting
      }));

      // Sort by status: active first, then expired
      return [...transformedJobs].sort((a, b) => {
        // Active status gets priority 1, expired gets priority 2
        const getPriority = (status) => {
          if (status === 'active') return 1;
          if (status === 'expired') return 2;
          return 3; // Unknown status
        };
        
        const priorityA = getPriority(a.scoutedStatus);
        const priorityB = getPriority(b.scoutedStatus);
        return priorityA - priorityB;
      });
    },
    shouldShowJobList() {
      if (this.userBasedMatching) {
        return true; 
      }
      return this.serverJDs.length > 0;
    },
  },
  mounted() {
    this.changeBodyBackground();
  },

  async created() {
    if (this.userBasedMatching && this.filteredJDs.length === 0) {
      await this.loadRecommendedJDs();
    }
  },

  watch: {
    profileView: {
      handler(newView) {
        if (newView === 'jdList') {
          this.$nextTick(() => {
            if (this.$refs.jdListContainer && this.preservedState) {
              this.$refs.jdListContainer.scrollTop =
                this.preservedState.scrollPosition || 0;
            }
          });
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.toggle-container {
  margin-right: 10px;
  background: #fff;
  border-radius: 8px;
  height: 43px;
  width: 235px;
  flex-shrink: 0;
}
.jd-list-wrapper {
  height: 84vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #EBEFF1;
}

.scouted-jd-list {
  max-height: 180px;
  overflow-y: auto;
  padding-right: 4px;
}

.jd-header {
  flex: 0 0 auto;
  padding: 2px;
  margin-top: 10px;
  width: 100%;
  background: #fff;
  border-radius: 10px;
  height: 53px;
}

.catg-area,
.loader-container {
  flex: 1 1 0%;
  overflow: auto;
  overflow-x: hidden;
  min-height: 0;
  position: relative;
  display: flex;
  align-items: flex-start;
  background-color: white;
}

.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.inner-loader-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
}

.list-button {
  min-width: 100px;
  background: #006c6b;
  padding: 5px 20px !important;
  border-radius: 0px !important;
  font-size: 12px;
}

.text-center {
  text-align: center !important;
}

.matchButton {
  width: 10%;
  background: #fff !important;
  border: 2px solid white !important;
  vertical-align: middle;
}

.jd-header p {
  font-size: 24px;
  font-weight: 600;
  margin: auto;
  padding: 10px;
}

.ptop-5 {
  padding-top: 5px !important;
}

label {
  color: #3c3c3c;
  padding: 5px;
  margin-top: 10px;
  font-size: 14px;
  font-weight: 400;
}
.top-controls {
  width: 100%;
  justify-content: space-between;
}

.search-container {
  flex: 1;
  height: 43px;
  background: #fff;
  border-radius: 8px;
  max-width: 360px !important;
  position: relative;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 10px;
  width: 100%;
}

.search-icon {
  position: absolute;
  left: 12px;
  color: #7a7e82;
  font-size: 14px;
  z-index: 1;
  pointer-events: none;
}

.search-input {
  padding: 0 25px 0 40px;
  flex: 1;
  height: 28px;
  border: none !important;
  border-right: none;
  border-radius: 4px;
  font-size: 14px;
  color: #7a7e82;
  box-sizing: border-box;
}

.search-btn-custom {
  background-color: rgb(20, 184, 166) !important;
  border-color: rgb(20, 184, 166) !important;
  width: 55px !important;
  max-width: 55px !important;
  min-width: 55px !important;
  font-size: 14px !important;
  padding: 8px !important;
}

.search-btn-custom:disabled {
  background-color: #A0D8D0 !important;
  border-color: #A0D8D0 !important;
  cursor: not-allowed;
  opacity: 0.7;
}

.search-input::placeholder {
  color: #979B9F;
  font-size: 12px;
}

.search-input:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.search-button:disabled {
  opacity: 0.6;
}

.search-disabled .search-input-wrapper {
  opacity: 0.6;
}

.search-button {
  min-width: 100px;
  height: 28px;
  border-radius: 4px;
  padding: 0 25px;
  background: #4F46E5;
  color: #fff;
  border: 1px solid #4F46E5;
  border-left: none;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  white-space: nowrap;
  box-sizing: border-box;
  font-weight: bold;
}

.search-button:hover:not(:disabled) {
  background: #4338ca;
  border-color: #4338ca;
}

.search-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.search-input:focus {
  outline: none;
  border: 1px solid #7a7e82;
  border-right: none;
}

.table {
  /* border-collapse: collapse; */
  width: 100%;
  font-size: 12px;
}

.table th,
tr {
  border: 2px solid #c4c4c4;
}

.table th {
  /* padding: 30px 10px 20px 10px; */
  padding: 5px;
  text-align: center;
  border-bottom: 1px solid black;
  font-size: 14px;
  color: #fff;
}

thead {
  background-color: #787878;
}

.collapse-icon {
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  user-select: none;
  min-width: 20px;
  text-align: center;
  margin-right: 40px; 
}

/* Custom Tooltip Styles */
.tooltip-container {
  position: relative;
  display: inline-block;
}

.custom-tooltip {
  visibility: hidden;
  opacity: 0;
  background-color: #787878;
  color: white;
  text-align: center;
  border-radius: 10px;
  padding: 8px 12px;
  position: absolute;
  z-index: 1000;
  top: 125%;
  left: 50%;
  transform: translateX(-50%);
  white-space: normal;
  max-width: 250px;
  font-size: 12px;
  font-weight: 500;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  pointer-events: none;
}

.custom-tooltip::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #787878 transparent;
}

.tooltip-container:hover .custom-tooltip {
  visibility: visible;
  opacity: 1 !important;
}

/* Ensure tooltip is fully opaque even when parent has reduced opacity */
.search-disabled .custom-tooltip {
  opacity: 0 !important;
}

.search-disabled.tooltip-container:hover .custom-tooltip {
  opacity: 1 !important;
}

.jd-header-fixed {
  padding: 10px 15px;
  background-color: #F7FFF4;
  min-height: 73px;
  /* border-bottom: 2px solid #f0f0f0; */
  flex-shrink: 0;
}

/* Custom Radio Styles for Search Type */
.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #fff !important;
  border-color: #adb5bd !important;
  box-shadow: none !important;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: none !important;
  background-color: #2F80ED !important;
  border-radius: 50% !important;
  transform: scale(0.7) !important;
}
</style>
